export const user = {
    getUserInfo: '/api/feihua/v1/user/getUserInfo',
    login: '/api/feihua/v1/live/smallclass/login',
    connectWechat: '/api/feihua/v1/wxapp/user/connectWechat',
    certificate: '/api/feihua/v1/user/certificate',
    visitorBindPhoneSms: '/api/feihua/v1/user/visitorBindPhoneSms',
    orderList: '/api/feihua/v1/pay/h5/order/list',
    // 获取订单详情接口
    orderDetail: '/api/feihua/v1/pay/h5/order/detail',
    recordList: '/api/feihua/v1/activity/recordList',
    reservationList: '/api/feihua/v1/live/smallclass/reservation/info',
    reservationStatus: '/api/feihua/v1/live/smallclass/reservation/status',
    // 获取正价课-预约小班直播课信息
    sysReservationSysInfo: '/api/feihua/v1/live/smallclass/sysReservation/sysInfo',
    // 正价课 - 小班直播课预约接口
    sysReservationStatus: '/api/feihua/v1/live/smallclass/sysReservation/status',
    // 【英语】——获取小班直播课列表
    reservationEnList: '/api/feihua/v1/live/smallclass/reservation/eng/list',
    // 【英语】——获取小班直播课预约信息
    reservationoldEnInfo: '/api/feihua/v1/live/smallclass/reservation/eng/info',

    // 【英语】——获取小班直播课预约信息——体验课
    reservationEnInfo: '/api/feihua/v2/live/smallclass/reservation/eng/info',
    // 【英语】——小班直播课预约——体验课
    reservationEnStatus: '/api/feihua/v2/live/smallclass/reservation/eng/status',
    // 【英语】——获取小班直播课预约信息——正价课
    sysReservationEnSysInfo: '/api/feihua/v2/live/smallclass/sysReservation/eng/sysInfo',
    sysReservationEnSysStatus: '/api/feihua/v2/live/smallclass/sysReservation/eng/status',

    // 【英语/阅读】小班直播课【重新预约】接口——体验课/正价课
    reserveAgainInfo: '/api/feihua/v1/live/smallclass/againReservation/Info',
    reserveAgainStatus: '/api/feihua/v1/live/smallclass/update/liveTime',
    // 正价课
    reserveAgainInfoV2: '/api/feihua/v2/live/smallclass/againReservation/Info',

    // 领课+白名单接口
    leadClass: '/api/feihua/v1/live/smallclass/liveLoginAccountVideoResource',

    // 获取用户的试学期和课表完课信息
    pointData: '/api/feihua/v1/course/pointData'
};

export const cash = {
    withdrawCheck: '/api/feihua/v1/course/dailyAttend/withdrawCheck',
    withdraw: '/api/feihua/v1/course/dailyAttend/withdraw',
    upgrade: '/api/feihua/v1/course/dailyAttend/upgrade',
    // 转介绍提现
    withdrawCreate: '/api/feihua/v1/pay/h5/withdrawCreate'
};

export const teacherInfo = {
    // getDrawCashTeacherInfo: '/api/feihua/v1/user/exp/getDrawCashTeacherInfo',
    // getMmTeacherInfo: '/api/feihua/v1/user/exp/getMmTeacherInfo',
    // teacherInfos: `/api/feihua/v1/user/learn/teacherInfo`,
    entTeacherInfo: '/api/feihua//v1/user/exp/entTeacherInfo'
};

export const weekcard = {
    wxAppLogin: '/api/feihua/v1/user/wxAppLogin',
    wxAppCodeToPhone: '/api/feihua/v1/user/wxAppCodeToPhone',
    bindPhoneWithoutCode: '/api/feihua/v1/user/bindPhoneWithoutCode',
    receiveProRights: '/api/feihua/v1/activity/share/receiveProRights',
    obtainCoupon: '/api/feihua/v1/coupon/obtainCoupon',
    sendMsgCode: '/api/feihua/v1/user/sendLoginMsgCode',
    loginBySms: '/api/feihua/v1/user/h5/loginBySms',
    bindPhoneByUid: '/api/feihua/v1/user/bindPhoneByUnionId',
    viewRelationUp: '/api/feihua/v1/wxapp/viewRelationUp',
};

export const poster = {
    getPosterList: '/api/feihua/v1/activity/invitePoster',
    getShareText: '/api/feihua/v1/activity/shareCopywriting',
    shareReport: '/api/feihua/v1/activity/inviteShareReport'
};

export const studyreport = {
    shareDetail: '/api/feihua/v1/course/shareDetail',
    readFeedback: '/api/feihua/v1/course/readFeedback'
};

// 分享得诗词卡活动落地页
export const shareCardActivity = {
    joinShareCard: '/api/feihua/v1/activity/joinShareCard',
    joinInfo: '/api/feihua/v1/activity/joinInfo',
};

// 分享得诗词卡活动页
export const shareActivity = {
    sharePunchInfo: '/api/feihua/v1/activity/sharePunchInfo',
    sharePunchInfoMiniApp: '/api/feihua//v1/activity/sharePunchInfoMiniApp',
    shareCardUp: '/api/feihua/v1/activity/shareCardUp',
    getOssToken: '/api/feihua/v2/oss/token',
    shareImgUp: '/api/feihua/v1/activity/shareImgUp',
};

export const logReport = {
    reportGetInviteQrCode: '/api/feihua/v1/activity/reportGetInviteQrCode'
};

// 阶段性学习报告
export const phaseStudyReport = {
    stageDetail: '/api/feihua/v1/course/stageDetail'
};

// 轻体验小程序相关
export const miniapp = {
    courseList: '/api/feihua/v2/course/home',
    shareDetail2: '/api/feihua/v2/course/miniapp/shareDetail2',
    getMiniAppUserInfo: '/api/feihua/v1/user/getUserInfo',
    verifySession: '/api/feihua/v1/course/session/verifySession',
    // 环节上报
    reportSession: '/api/feihua/v1/course/session/report',
    // 环节结果
    resultSession: '/api/feihua/v1/course/session/result',
    // 课程到课上报接口
    attendanceReport: '/api/feihua/v2/course/attendanceReport',
    // 生成学习报告
    learnReport: '/api/feihua/v2/course/miniapp/learnReport',
    // 生成周报
    weekReport: '/api/feihua/v1/week/course',
};

// 小课包相关
export const miniCoursePackage = {
    // 首页信息
    home: '/api/feihua/v1/wxapp/coursePackage/home',
    // 兑换码
    payRedeem: '/api/feihua/v1/pay/redeem',
    // 获得课表信息
    getCourseInfo: '/api/feihua/v2/wxapp/coursePackage/info',
    // 目录接口
    catalog: '/api/feihua/v2/wxapp/coursePackage/catalog',
    // 课程等级列表
    levelList: '/api/feihua/v2/course/level/list',
    // 切换级别
    switchCourseLevel: '/api/feihua/v2/course/switchCourseLevel',
    // 课程购买预下单接口
    createOrder: '/api/feihua/v1/pay/h5/createOrder',
    // 获取支付二维码
    getThirdPayQueryForQr: '/api/feihua/v1/pay/h5/getThirdPayQueryForQr',
    // 轮询订单
    orderLoop: '/api/feihua/v1/pay/h5/order/loop',
};

// 商城接口相关
export const mall = {
    combinationInfo: '/api/feihua/v1/pay/order/combinationInfo',
    openCombinationRight: '/api/feihua/v1/pay/order/openCombinationRight',
    giftList: '/api/feihua/v1/activity/giftList',
    // 商品信息
    giftInfoById: '/api/feihua/v1/pay/h5/giftInfoById',
    createOrder: '/api/feihua/v1/pay/h5/createOrder',
    miniappIndex: '/api/feihua/v2/index',

    giftDetail: '/api/feihua/v1/activity/giftDetail',
    logisticInfoListApi: '/api/feihua/logisticInfoList',
    logisticInfoDetailApi: '/api/feihua/logistic/detail',
    deliveryModifyApi: '/api/feihua/v1/activity/deliveryInfo/modify',
    logisticInfoUpdateApi: '/api/feihua/logisticInfo/update',
    areaListApi: '/api/feihua/logistic/areaList',
    logisticInfoAddApi: '/api/feihua/logisticInfo/add',
    redeemCollectApi: '/api/feihua/v1/activity/redeem/collect',

    // 市场测试支付，获取商品接口
    levelInfo: '/api/feihua/v2/wxapp/coursePackage/levelInfo',
};

// 首页三个tab的数据
export const home = {
    // 发现页-精选内容
    homeData: '/api/feihua/v2/wxapp/coursePackage/index',
    // 学习页
    learnPageData: '/api/feihua/v2/wxapp/coursePackage/home',
    // 我的页
    myPageData: '/api/feihua/v2/wxapp/coursePackage/mine',
    // 公共信息
    getPub: '/api/feihua/v1/pub/config'
};

export const campClass = {
    // 营课获取信息接口
    joinClassInfo: '/api/feihua/v1/camp/joinClassInfo',
    // 营课报名接口
    campAttend: '/api/feihua/v1/camp/attend',
    // 微信code吗登录
    wxH5Login: '/api/feihua/v1/user/wxH5Login',
    // 绑定手机号
    bindPhoneByUnionId: '/api/feihua/v1/user/bindPhoneByUnionId',
    // 跳转小程序——获取小程序 urlLink 跳转链接
    getMpUrlLink: '/api/feihua/v1/user/wxAppGenUrlLink',
    // 获取企微老师账户信息
    getWechatAccount: '/api/feihua/user/entWechatAccount',
    // 用户参与标识前置查询信息
    userJoinInfo: '/api/feihua/user/joinInfo',
};

export const campReport = {
    // 获取结营报告详情
    getCampReportDetail: '/api/feihua/v1/course/stage/detail',
    // 结营体验课评价
    campReportEvaluate: '/api/feihua/v1/course/stage/evaluate',
    // 获取作业批改结果详情
    getHomeworkResultDetail: '/api/feihua/v1/course/homework/res',
};

export const h5Question = {
    // H5题目 - 获取题目数据
    getQuestionDetail: '/api/feihua/v2/course/session/question/detail',
    // H5题目 - 获取 prompt 交互 gpt 的结果，语音流交互(AI提示、AI点评)
    getAudioReplyAi: '/api/feihua/v1/live/smallclass/user/audioReply',
    // H5题目 - 获取prompt模版信息
    getPromptTemplateApi: '/api/feihua/v1/live/smallclass/getPromptTemplate',
};

// 参考答案接口
export const answer = {
    referenceAnswerList: '/api/feihua/v1/referenceAnswer/list',
    bookList: '/api/feihua/v1/referenceAnswer/book/list',
    answerPageDetail: '/api/feihua/v1/textbook/answerPageDetail',
    answerPageList: '/api/feihua/v1/textbook/answerPageList',
    audioList: '/api/feihua/v1/textbook/audioList',
};

// 测评相关接口
export const evaluation = {
    getEvaluationQuestionJson: '/api/feihua/v1/course/evalCourse/resource',
    reportEvaluationResult: '/api/feihua/v1/eval/course/session/report',
    getEvaluationReport: '/api/feihua/v1/eval/course/detail',
};

export const reserve = {
    reserveNewInfo: '/api/feihua/v3/live/smallclass/reservation/uniteInfo',
    regularReserveNewInfo: '/api/feihua/v3/live/smallclass/reservation/flexible/uniteInfo',
    reserveNewStatus: '/api/feihua/v3/live/smallclass/reservation/uniteStatus',
};

export const motivate = {
    getMotivateInfo: '/api/feihua/v1/incent/user/figure/info',
    purchaseEnergy: '/api/feihua/v1/incent/user/buy/energy',
    charge: '/api/feihua/v1/incent/user/figure/charge',
    levelUp: '/api/feihua/v1/incent/user/figure/upgrade',
};
